import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/user/device/device_phone_mobile.png';
import _imports_1 from '@/assets/img/user/device/tv_ic.png';
const _withScopeId = n => (_pushScopeId("data-v-426da7d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "devicePage" };
const _hoisted_2 = { class: "tabWrapper" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "deviceText" }, [
    /*#__PURE__*/ _createElementVNode("p", null, " 如发现异常的登录设备，可点击「强制下线」按钮，移除该设备。移除后该设备需要重新进行登录验证。 ")
], -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "deviceText" }, [
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode(" 联系您的专属顾问或拨打客服电话： "),
        /*#__PURE__*/ _createElementVNode("strong", null, "400-888-1506"),
        /*#__PURE__*/ _createTextVNode("，我们将协助您进行账号的安全防护。 ")
    ])
], -1));
const _hoisted_5 = { class: "deviceText mt-36" };
const _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 账号");
const _hoisted_7 = { class: "nowUserId" };
const _hoisted_8 = /*#__PURE__*/ _createTextVNode("已登录的设备： ");
const _hoisted_9 = { class: "nowDevice flex-align-center" };
const _hoisted_10 = {
    key: 0,
    src: _imports_0,
    alt: ""
};
const _hoisted_11 = {
    key: 1,
    src: _imports_1,
    alt: ""
};
const _hoisted_12 = {
    key: 2,
    class: "nowText"
};
const _hoisted_13 = { class: "flex-align-center deviceBottom" };
const _hoisted_14 = { class: "status-list" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "status-item" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "当前状态："),
    /*#__PURE__*/ _createElementVNode("span", { class: "status-label-text" }, "已登录")
], -1));
const _hoisted_16 = { class: "status-item" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录时间：", -1));
const _hoisted_18 = { class: "status-label-text" };
const _hoisted_19 = { class: "status-item" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录IP：", -1));
const _hoisted_21 = { class: "status-label-text" };
const _hoisted_22 = { class: "status-item" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "status-label" }, "登录地址：", -1));
const _hoisted_24 = { class: "status-label-text" };
const _hoisted_25 = {
    key: 0,
    class: "deviceRight"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = { class: "noMore" };
import history from './components/history.vue';
import { tokenSearch, tokenKick } from '@/api/exercise';
import Empty from '@/components/common/Empty.vue';
import BScroll from '@/components/common/BetterScroll.vue';
import { appPort, closeWebView, isLogin, userLogin, getUserId, hiddenAppNavBar } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { Toast } from 'vant';
import { ref, onMounted, getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { proxy: { $showLoading, $hideLoading, $dialog } } = getCurrentInstance();
        const userId = getUserId();
        const isApp = ref(appPort());
        const dataList = ref([]);
        const tabVal = ref(0);
        const listBs1 = ref(); // 上拉加载
        let loaded = ref(false); // 是否加载完成
        const noMore = ref(false); // 是否还有更多
        var pageNo = 1; //当前页数
        var pageCount = 1; //共有多少页
        const backFn = () => {
            if (isApp.value) {
                closeWebView();
            }
            else {
                history.go(-1);
            }
        };
        // 获取数据
        const getData = () => {
            if (!isLogin) {
                userLogin();
                return;
            }
            $showLoading();
            loaded.value = false;
            tokenSearch({
                page: pageNo
            }).then((res) => {
                loaded.value = true;
                $hideLoading();
                if (res.code === 200) {
                    pageCount = res.data.pages;
                    if (pageNo === 1) {
                        dataList.value = res.data.items;
                    }
                    else {
                        dataList.value = dataList.value.concat(res.data.items);
                    }
                    listBs1.value?.refreshBs();
                    if (pageNo >= pageCount) {
                        noMore.value = true;
                    }
                    else {
                        noMore.value = false;
                        pageNo++;
                    }
                }
            });
        };
        // 切换tab
        const selectTab = val => {
            tabVal.value = val;
            pageNo = 1;
            if (val === 0) {
                getData();
                listBs1.value?.scrollTo(0, 0);
            }
        };
        // 强制下线
        const offLine = (id, val) => {
            $dialog
                .confirm({
                message: `确认要将 ${id} 强制下线吗？`
            })
                .then(() => {
                tokenKick({
                    token: val
                }).then((res) => {
                    if (res.code === 200) {
                        Toast('强制下线成功！');
                        getData();
                    }
                });
            })
                .catch(() => { });
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        onMounted(() => {
            getData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isApp.value)
                    ? (_openBlock(), _createBlock(Header, {
                        key: 0,
                        onBackFn: backFn,
                        showBack: true,
                        isColor: true,
                        pageTitle: '登录设备管理'
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["tab", { inApp: isApp.value }])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["tab-item", { active: tabVal.value === 0 }]),
                            onClick: _cache[0] || (_cache[0] = ($event) => (selectTab(0)))
                        }, " 已登录设备 ", 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["tab-item", { active: tabVal.value === 1 }]),
                            onClick: _cache[1] || (_cache[1] = ($event) => (selectTab(1)))
                        }, " 登录日志 ", 2)
                    ], 2)
                ]),
                (tabVal.value === 0)
                    ? (_openBlock(), _createBlock(BScroll, {
                        key: 1,
                        ref: (_value, _refs) => {
                            _refs['listBs1'] = _value;
                            listBs1.value = _value;
                        },
                        options: {
                            scrollY: true,
                            scrollX: false,
                            click: true,
                            mouseWheel: true,
                            scrollbar: {
                                fade: false,
                                interactive: true
                            },
                            pullUpLoad: true
                        },
                        loaded: _unref(loaded),
                        noMore: noMore.value,
                        onUpLoad: getData,
                        domStyle: {
                            position: 'relative',
                            height: 'calc(100vh - 0.9rem)'
                        }
                    }, {
                        default: _withCtx(() => [
                            _hoisted_3,
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("p", null, [
                                    _hoisted_6,
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(userId)), 1),
                                    _hoisted_8
                                ])
                            ]),
                            _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        class: "deviceList",
                                        key: key
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            (item.clientType !== 4)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                                                : (_openBlock(), _createElementBlock("img", _hoisted_11)),
                                            _createTextVNode(" " + _toDisplayString(item.clientTypeName) + " ", 1),
                                            (item.current)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "当前设备"))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("div", _hoisted_14, [
                                                _hoisted_15,
                                                _createElementVNode("div", _hoisted_16, [
                                                    _hoisted_17,
                                                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.createdDate), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_19, [
                                                    _hoisted_20,
                                                    _createElementVNode("span", _hoisted_21, _toDisplayString(item.ip), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                    _hoisted_23,
                                                    _createElementVNode("span", _hoisted_24, _toDisplayString(item.city), 1)
                                                ])
                                            ]),
                                            (!item.current)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                    _createElementVNode("button", {
                                                        onClick: _withModifiers(($event) => (offLine(item.userId, item.token)), ["stop"])
                                                    }, " 强制下线 ", 8, _hoisted_26)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]));
                                }), 128))
                            ]),
                            _withDirectives(_createVNode(Empty, null, null, 512), [
                                [_vShow, _unref(pageCount) == 0 && noMore.value]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_27, " 没有更多了 ", 512), [
                                [_vShow, noMore.value && _unref(pageCount) === _unref(pageNo)]
                            ])
                        ]),
                        _: 1
                    }, 8, ["loaded", "noMore", "domStyle"]))
                    : (_openBlock(), _createBlock(history, { key: 2 }))
            ]));
        };
    }
});
